// src/js/modules/tooltip-activator.js

// --- Configuration (can be centralized in config.js if preferred) ---
const HOTSPOT_CONTAINER_SELECTOR = '.ggskin_hotspot.info-hotspot-container'; // Selector for the main div of your info hotspots
const TOOLTIP_TRIGGER_SELECTOR = '.tooltip-trigger'; // Selector for the element inside the hotspot that triggers Tippy

let targetHotspotId = null; // Stores the ID passed from the parent

/**
 * Stores the hotspot ID received from the parent window message.
 * @param {string|null} hotspotId The ID of the hotspot to activate, or null.
 */
export function setTargetHotspot(hotspotId) {
    targetHotspotId = hotspotId ? String(hotspotId).trim() : null; // Ensure string or null
    if (targetHotspotId) {
        console.log(`<<< PANO TooltipActivator: Target hotspot ID set to: '${targetHotspotId}'`);
    }
}

/**
 * Attempts to find the target hotspot (by data-hid) and show its Tippy tooltip.
 * Should be called AFTER the panorama node has changed, data-hid attributes are set,
 * AND Tippy has been initialized for the current hotspots.
 */
export function tryActivateTargetTooltip() {
    if (!targetHotspotId) {
        // console.log("<<< PANO TooltipActivator: No target hotspot ID currently set."); // Optional log
        return; // No target specified
    }

    console.log(`<<< PANO TooltipActivator: Attempting to activate tooltip for target ID: '${targetHotspotId}'`);

    // Construct the precise selector for the target container
    const targetSelector = `${HOTSPOT_CONTAINER_SELECTOR}[data-hid="${targetHotspotId}"]`;
    const targetContainer = document.querySelector(targetSelector);

    if (targetContainer) {
        console.log(`<<< PANO TooltipActivator: Found target container element for '${targetHotspotId}'.`);
        const tooltipTrigger = targetContainer.querySelector(TOOLTIP_TRIGGER_SELECTOR);

        if (tooltipTrigger) {
            console.log(`<<< PANO TooltipActivator: Found tooltip trigger inside container.`);
            // Check if Tippy instance is attached and ready
            if (tooltipTrigger._tippy && typeof tooltipTrigger._tippy.show === 'function') {
                console.log(`<<< PANO TooltipActivator: Found Tippy instance for '${targetHotspotId}'. Calling show().`);
                tooltipTrigger._tippy.show();

                // Optional: Scroll into view if needed
                // tooltipTrigger.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });

                // --- IMPORTANT: Clear the target ID after activation ---
                // Prevents the same tooltip from reopening accidentally on subsequent
                // interactions within the same pano load unless triggered by a new message.
                targetHotspotId = null;
                console.log("<<< PANO TooltipActivator: Cleared target hotspot ID after activation.");

            } else {
                console.warn(`<<< PANO TooltipActivator: Tooltip trigger found for '${targetHotspotId}', but no Tippy instance (_tippy) or show method found. Was initializeTippy() called correctly beforehand?`);
            }
        } else {
            console.warn(`<<< PANO TooltipActivator: Target container found for '${targetHotspotId}', but trigger element ("${TOOLTIP_TRIGGER_SELECTOR}") not found inside.`);
        }
    } else {
        console.warn(`<<< PANO TooltipActivator: Target hotspot container with selector "${targetSelector}" not found in the DOM.`);
        // Clear the ID if the target wasn't found, otherwise it will keep trying on subsequent events
        targetHotspotId = null;
    }
}